import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Button, Tab, Tabs, useMediaQuery, useTheme } from "@mui/material";
import { useContext, useEffect } from "react";
import { PaymentFormContext } from "../../../Shared/components/PaymentForm/PaymentFormContext";
import { TabNames, TabValues, UpdateOrderTexts } from "../deliveryModalUtils/const-enums-types";
import { handleTabChange } from "../deliveryModalUtils/helpers";
import { UpdateOrderDeliveryPickupModalContext } from "../deliveryModalUtils/UpdateOrderDeliveryPickupModalContext";
export const TabsSelectorComponent = ({ initTabProps, addressesData: { addressState: { usesLocation, usesZipCodes, pickupLocations }, }, shouldDisplayPaymentForm, setShouldDisplayPaymentForm, }) => {
    const { tabValue, setTabValue } = useContext(UpdateOrderDeliveryPickupModalContext);
    const { setBalance } = useContext(PaymentFormContext);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"), { noSsr: true });
    useEffect(() => {
        let mounted = true;
        if (initTabProps.initTabValue !== tabValue && !!mounted) {
            setTabValue(initTabProps.initTabValue);
        }
        return () => {
            mounted = false;
            setTabValue(TabValues.DELIVERY);
        };
    }, []);
    const shouldScrollbarDisplay = tabValue === TabValues.ADD_NEW_ADDRESS && isMobile;
    if (shouldDisplayPaymentForm)
        return (_jsx(Button, Object.assign({ size: "medium", startIcon: _jsx(ArrowBackIcon, {}), onClick: () => {
                setShouldDisplayPaymentForm(false);
                setTabValue(initTabProps.initTabValue);
                setBalance(undefined);
            } }, { children: UpdateOrderTexts.BACK })));
    else
        return (_jsxs(Tabs
        // Forces component to re-render when key prop changes, preventing scroll calculation issues.
        , Object.assign({ value: tabValue, onChange: handleTabChange(setTabValue, shouldDisplayPaymentForm, setShouldDisplayPaymentForm), allowScrollButtonsMobile: true, variant: "scrollable", scrollButtons: "auto", "aria-label": "update-delivery-modal-tabs" }, { children: [usesZipCodes ? _jsx(Tab, { label: TabNames.DELIVERY }) : null, usesLocation && !!pickupLocations.length ? _jsx(Tab, { label: TabNames.PICKUP }) : null, tabValue === TabValues.ADD_NEW_ADDRESS ? _jsx(Tab, { label: TabNames.ADD_NEW_ADDRESS }) : null] }), shouldScrollbarDisplay ? "scrollable" : "standard"));
};
